export interface IAttachment {
	fields: {
		item?: object[];
	};
}
